import React from 'react';
import BackButton from '../../../../components/navigation/back-button';
import HeaderTitle from '../../../../components/typography/header-title';
import PiiTable from '../../../../components/AuditPii/PIITable';
import { Box } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../../../../components/tabs/tabPanel';
import { useState } from 'react';
import UserIdTokenTable from '../../../../components/AuditPii/UserIdToken';
//import TaskManagement from '../../../../components/administration/taskManager';
const a11yProps = ({ index }) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};
const PIIDownload = () => {
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <HeaderTitle
                title={'Download PII Data'}
                subtitle={'Provide User Id and download the PII data'}
            />
            <Box
                sx={{
                    width: '100%',
                    marginTop: '30px',
                }}
            >
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                    >
                        <Tab
                            wrapped={true}
                            label="User Id/Phone Number"
                            {...a11yProps(0)}
                        />
                        <Tab
                            wrapped={true}
                            label="User Id/Job Id"
                            {...a11yProps(1)}
                        />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <UserIdTokenTable/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <PiiTable />
                </TabPanel>
            </Box>
        </>
    );
};

export default PIIDownload;
